import { NavigateFunction } from "react-router-dom";

const getHeaderOffset = () => {
	const header = document.querySelector(".header") as HTMLElement | null;
	const headerHeight = header?.getBoundingClientRect().height ?? 0;

	return headerHeight + 18;
};

const getAnchorTop = (el: Element) => {
	return Math.max(window.scrollY + el.getBoundingClientRect().top - getHeaderOffset(), 0);
};

const getMobileFormScrollTop = () => {
	const isMobileLayout = window.matchMedia("(max-width: 768px)").matches;
	if (!isMobileLayout) return 0;

	const rightIntro = document.querySelector(".home-intro-body .right") as HTMLElement | null;
	if (!rightIntro) return 0;

	const rightIntroStyle = window.getComputedStyle(rightIntro);
	const introHeight = rightIntro.getBoundingClientRect().height;
	const introMarginBottom = Number.parseFloat(rightIntroStyle.marginBottom || "0");

	return Math.max(introHeight + introMarginBottom, 0);
};

export const scrollToAnchor = (hash: string, behavior: ScrollBehavior = "smooth") => {
	const el = document.querySelector(hash);
	if (!el) return null;

	const top = getAnchorTop(el);

	window.scrollTo({
		top,
		behavior,
	});

	return el;
};

const focusFormAfterScrollTop = (targetTop: number) => {
	const form = document.querySelector("#form-card");
	const firstInput = form?.querySelector("input, textarea") as HTMLElement | null;
	if (!firstInput) return;

	let stableFrames = 0;
	let lastScrollY = window.scrollY;
	let animationFrame = 0;
	const startedAt = Date.now();

	const waitForTop = () => {
		const currentScrollY = window.scrollY;
		const isAtTarget = Math.abs(currentScrollY - targetTop) <= 2;
		const isStable = Math.abs(currentScrollY - lastScrollY) < 1;

		stableFrames = isAtTarget && isStable ? stableFrames + 1 : 0;
		lastScrollY = currentScrollY;

		if (stableFrames >= 6) {
			firstInput.focus({ preventScroll: true });
			return;
		}

		if (Date.now() - startedAt > 2500) return;

		animationFrame = window.requestAnimationFrame(waitForTop);
	};

	animationFrame = window.requestAnimationFrame(waitForTop);

	const handleScrollEnd = () => {
		if (Math.abs(window.scrollY - targetTop) <= 2) {
			if (animationFrame) {
				window.cancelAnimationFrame(animationFrame);
			}

			firstInput.focus({ preventScroll: true });
		}
	};

	window.addEventListener("scrollend", handleScrollEnd, { once: true });
};

export const scrollToForm = (navigate: NavigateFunction, hash: string = "#form-card") => {
	navigate({ pathname: "/", hash }, { replace: true, state: { skipHashScroll: true } });

	setTimeout(() => {
		if (hash !== "#form-card") {
			scrollToAnchor(hash);
			return;
		}

		const top = getMobileFormScrollTop();

		window.scrollTo({
			top,
			behavior: "smooth",
		});

		focusFormAfterScrollTop(top);
	}, 80);
};
